import React from "react";
import { useLocation, useHistory } from "react-router";
import { useDispatch } from "react-redux";

import { getUserInfo } from "../../actions/oauthActions";
import { getAccessToken } from "../../services/authService";
import { ActionTypes } from "../../constants";


export default function Callback() {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryString = new URLSearchParams(location.search);

    const code = queryString.get("code");
    const error = queryString.get("error");
    const onError = () => {
        dispatch({ type: ActionTypes.LOGIN_FAILURE, message: "Authentication error" });
        history.replace("/login");
    }
    if (!!error || !code) {
        onError();
    }

    const getAuthToken = async () => {
        try {
            await getAccessToken(code);
            getUserInfo()(dispatch);
            history.replace("/");
        } catch (ex) {
            if (ex.response && ex.response.status === 400) {
                onError();
            }
        }
    };

    getAuthToken();
    return null;
}
